<div class="grid grid-cols-4 gap-4 md:gap-y-0">
  <div class="row-span-2 col-span-4 md:col-span-1">
    <!-- investment summary -->
    <div class="widget-card card bg-white">
      <div class="border-b border-b-light-grey p-3 font-bold text-lg">
        <mat-icon class="text-primary align-middle material-icons-outlined mr-1.5">summarize</mat-icon>
        Investment Summary
      </div>
      <div class="p-3 text-md grid sm:grid-cols-2 md:grid-cols-1">
        @for (item of investmentSummaryItems; track item) {
          <div class="py-2">
            <div class="font-semibold">
              {{ item.label }}
            </div>
            <div>
              @if (item.isDate) {
                {{ item.value | toString | dateFormat:'MMMM yyyy' }}
              } @else {
                @if (item.isMillions) {
                  {{ item.value | toNumber | currencyFormat: investmentSummary?.currency :'Millions' }}
                } @else if (item.isMultiple) {
                  {{ item.value ? (item.value | toNumber | number:'1.1-1') + "x" : "N/A" }}
                } @else {
                  {{ item.value ?? "N/A"}}
                }
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="grid grid-rows-2 gap-4 col-span-4 md:col-span-3">
    <div class="grid grid-cols-7 gap-4">
      <!-- financial performance -->
      <div class="col-span-5">
        <app-financial-performance-widget [investmentSummary]="investmentSummary" [widgets]="caseStudyDetails()?.widgets"></app-financial-performance-widget>
      </div>
      <!-- financial metrics -->
      <div class="widget-card card bg-white col-span-2">
        <div class="border-b border-b-light-grey p-3 flex justify-between">
          <div class="flex items-center">
            <mat-icon class="text-primary self-center material-symbols-outlined mr-1.5" color="text-primary">insert_chart</mat-icon>
            <div class="font-bold text-lg pl-1">Financial Metrics</div>
            <div class="font pl-2 text-grey text-sm">
              as of {{investmentSummary?.calendarDate | dateFormat : 'MM/dd/yyyy'}}
            </div>
          </div>
        </div>
        <div class="px-3 py-4 text-md">
          <div class="bg-background-color-light-grey bg-opacity-50 rounded-md p-3">
            <div class="border-b border-b-light-grey pb-2 flex justify-between">
              <div class="font-semibold">{{investmentSummary?.netDebtLabel}}</div>
              <div>{{ isConfidential ? confidential : (investmentSummary?.netDebt | currencyFormat: investmentSummary?.currency :'Millions') }}</div>
            </div>
            <div class="pt-2 flex justify-between">
              <div class="font-semibold">{{investmentSummary?.netDebtLabel}}/{{investmentSummary?.leverageMetricLabel}}</div>
                <div>{{ isConfidential ? confidential : (investmentSummary?.netLeverage | toNumber | number:'1.1-1') + 'x' }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <!-- investment highlights -->
      <div class="widget-card card bg-white">
        <div class="border-b border-b-light-grey p-3 font-bold text-lg">
          <mat-icon class="text-primary align-middle material-symbols-outlined mr-1.5" color="text-primary">lightbulb</mat-icon>
          Investment Highlights
        </div>
        <div class="p-3  text-md">
          @for (highlight of investmentHighlights; track highlight) {
            <ul class="list-disc ml-4">
              <li class="mb-2"> {{highlight}}</li>
            </ul>
          }
        </div>
      </div>
      <!-- status and performance -->
      <div class="widget-card card bg-white">
        <div class="border-b border-b-light-grey p-3 flex justify-between">
          <div class="flex items-center">
            <mat-icon class="text-primary self-center material-symbols-outlined mr-1.5" color="text-primary">monitoring</mat-icon>
            <div class="font-bold text-lg pl-1">Status and Performance</div>
            <div class="font pl-2 text-grey text-sm">
              as of {{investmentSummary?.calendarDate | dateFormat : 'MM/dd/yyyy'}}
            </div>
          </div>
          <div>
            <div class="status-chip" [ngClass]="investmentSummary?.keyPerformanceCommentary?.toLowerCase() === 'on plan' ? 'on-plan' : investmentSummary?.keyPerformanceCommentary?.toLowerCase() === 'below plan' ? 'below-plan' : investmentSummary?.keyPerformanceCommentary?.toLowerCase() === 'above plan' ? 'above-plan' : 'unknown'">
              {{investmentSummary?.keyPerformanceCommentary}}
            </div>
          </div>
        </div>
        <div class="p-3 text-md">
          @for (bulletpoint of statusAndPerformance; track bulletpoint) {
            <ul class="list-disc ml-4">
              <li class="mb-2"> {{bulletpoint}}</li>
            </ul>
          }
        </div>
      </div>
    </div>
  </div>
</div>
<div class="widget-card card bg-white min-h-10 mt-4">
  <div class="px-3 py-4 text-md font-semibold">
    Select Risks Include: {{caseStudyDetails()?.risksNarrative}}
  </div>
</div>
